export const SALE_PINS_KEY = 'sale-pins';

export function saleProductsKey(params: {
  limitProduct: number;
  offsetProduct: number;
  search: string;
  isPinnedOnly: boolean;
  onlyInStock: boolean;
  orderingColumn: string;
  orderingDirection: string;
  selectedLetter: string | null;
}) {
  return [
    'sale-products',
    params.limitProduct,
    params.offsetProduct,
    params.search,
    params.isPinnedOnly,
    params.onlyInStock,
    params.orderingColumn,
    params.orderingDirection,
    params.selectedLetter,
  ] as const;
}
